import {Component, OnInit} from '@angular/core';
import {BlogService} from "../../../shared/services/blog.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {
    blogs: any = [];

    constructor(private blogData: BlogService, public router: Router) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);
        this.get();

    }

    get(params: any = {}) {
        this.blogs = [];
        this.blogData.get(params).subscribe(data => {
            if (data && Array.isArray(data.data)) {
                this.blogs = data.data;
            }
        });
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }

    saveAtLocal(url: any, title) {
        localStorage.setItem('blog-title', JSON.stringify(title));
        this.router.navigateByUrl(url);
    }

}
